export const environment = {
    production: true,
    api: 'https://wegwijzerdenhaag.nl/api/public',
    nieuwkomer_api: 'https://wegwijzerdenhaag.nl/nieuwkomer/api',
    captcha: '6LcC8cogAAAAAM04pqP2qQELv0A574WK5N69Nk0C',
};
